import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Search } from "lucide-react";
import { colors, type, spacing, radius, formatCents } from "@/theme";
import { api } from "@/lib/api";
import { useRequireAuth } from "@/lib/useRequireAuth";

export default function AdminAvailability() {
  const navigate = useNavigate();
  const { user } = useRequireAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [failed, setFailed] = useState(new Set());

  const load = useCallback(async () => {
    const d = await api.adminMenuFull();
    const flat = [];
    d.categorie.forEach((c) => c.items.forEach((it) => flat.push({ ...it, cat: c.nome })));
    setItems(flat); setLoading(false);
  }, []);
  useEffect(() => { if (user) load(); }, [user, load]);
  if (!user) return null;

  const toggle = async (it) => {
    const next = !it.disponibile;
    setItems((p) => p.map((x) => x.id === it.id ? { ...x, disponibile: next } : x));
    setFailed((p) => { const n = new Set(p); n.delete(it.id); return n; });
    try { await api.setAvailability(it.id, next); }
    catch { setItems((p) => p.map((x) => x.id === it.id ? { ...x, disponibile: !next } : x)); setFailed((p) => new Set(p).add(it.id)); }
  };

  const filtered = items.filter((it) => it.nome.toLowerCase().includes(q.toLowerCase()));

  return (
    <div style={{ minHeight: "100vh", background: colors.bg }}>
      <div style={{ maxWidth: 640, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: `${spacing.md}px ${spacing.lg}px` }}>
          <button data-testid="back-button" onClick={() => navigate(-1)} style={plain}><ChevronLeft size={26} color={colors.ink} /></button>
          <div style={{ ...type.serif, fontSize: 22, color: colors.ink }}>Disponibilità</div>
          <div style={{ width: 26 }} />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: spacing.sm, background: colors.surface, border: `1px solid ${colors.line}`, borderRadius: radius.md, margin: `0 ${spacing.lg}px`, padding: `0 ${spacing.md}px`, height: 48 }}>
          <Search size={18} color={colors.inkSoft} />
          <input data-testid="availability-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca piatto…" style={{ flex: 1, border: "none", background: "transparent", ...type.sans, fontSize: 16, color: colors.ink }} />
        </div>

        {loading ? <div style={{ padding: spacing.xl, textAlign: "center", ...type.sans, color: colors.accent }}>Caricamento…</div> : (
          <div style={{ padding: spacing.lg, display: "flex", flexDirection: "column", gap: spacing.sm }}>
            {filtered.map((it) => (
              <div key={it.id} data-testid={`avail-row-${it.id}`} style={{ display: "flex", alignItems: "center", gap: spacing.md, background: colors.surface, borderRadius: radius.md, padding: spacing.md, border: `1px solid ${colors.line}` }}>
                <div style={{ flex: 1 }}>
                  <div style={{ ...type.sansSemi, fontSize: 16, color: it.disponibile ? colors.ink : colors.inkSoft }}>{it.nome}</div>
                  <div style={{ ...type.sans, fontSize: 12, color: colors.inkSoft, marginTop: 2 }}>{it.cat} · {formatCents(it.prezzo_cent)}{failed.has(it.id) ? " · ⚠︎ non salvato" : ""}</div>
                </div>
                <span style={{ ...type.sansMedium, fontSize: 12, color: it.disponibile ? colors.success : colors.danger }}>{it.disponibile ? "Disponibile" : "Esaurito"}</span>
                <button data-testid={`avail-switch-${it.id}`} onClick={() => toggle(it)} role="switch" aria-checked={it.disponibile} style={{ width: 48, height: 28, borderRadius: 14, border: "none", background: it.disponibile ? colors.success : colors.danger, position: "relative", padding: 0 }}>
                  <span style={{ position: "absolute", top: 3, left: it.disponibile ? 23 : 3, width: 22, height: 22, borderRadius: 11, background: "#fff", transition: "left .18s ease" }} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const plain = { background: "none", border: "none", display: "flex", padding: 0 };
